import { render, staticRenderFns } from "./ShowGprsOnLineLog.vue?vue&type=template&id=2b489036&"
import script from "./ShowGprsOnLineLog.vue?vue&type=script&lang=js&"
export * from "./ShowGprsOnLineLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports